/**
 * @generated SignedSource<<1129a5ea52d2bca847b621a81e4a33d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CheckChangePasswordTokenMutationInput = {
  clientMutationId?: string | null;
  resetPasswordToken: string;
};
export type ChangePasswordScreenCheckMutation$variables = {
  input: CheckChangePasswordTokenMutationInput;
};
export type ChangePasswordScreenCheckMutation$data = {
  readonly checkChangePasswordTokenMutation: {
    readonly __typename: "CheckChangePasswordToken";
    readonly message: string | null;
  };
};
export type ChangePasswordScreenCheckMutation = {
  response: ChangePasswordScreenCheckMutation$data;
  variables: ChangePasswordScreenCheckMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CheckChangePasswordToken",
    "kind": "LinkedField",
    "name": "checkChangePasswordTokenMutation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangePasswordScreenCheckMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChangePasswordScreenCheckMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "813e6a6db5c122c7326ed7d96f4e34a9",
    "id": null,
    "metadata": {},
    "name": "ChangePasswordScreenCheckMutation",
    "operationKind": "mutation",
    "text": "mutation ChangePasswordScreenCheckMutation(\n  $input: CheckChangePasswordTokenMutationInput!\n) {\n  checkChangePasswordTokenMutation(input: $input) {\n    __typename\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "1cd81000723e2204add06a47d8047337";

export default node;
